import React from "react";
import { PHASE_STYLES, STATUS_STYLES, SEVERITY_STYLES, PHASE_LABELS, STATUS_LABELS, SEVERITY_LABELS, CUSTOMER_PHASE_LABELS } from "../lib/constants";

const KIND_MAP = {
  phase: { styles: PHASE_STYLES, labels: PHASE_LABELS },
  status: { styles: STATUS_STYLES, labels: STATUS_LABELS },
  severity: { styles: SEVERITY_STYLES, labels: SEVERITY_LABELS },
  customer_phase: {
    styles: {
      in_vorbereitung: PHASE_STYLES.discovery,
      in_umsetzung: PHASE_STYLES.build,
      in_pruefung: PHASE_STYLES.review,
      freigabe: PHASE_STYLES.sign_off,
      live: PHASE_STYLES.betrieb,
    },
    labels: CUSTOMER_PHASE_LABELS,
  },
};

export const StatusPill = ({ kind = "status", value, sharp = false, className = "" }) => {
  const { styles, labels } = KIND_MAP[kind] || KIND_MAP.status;
  const style = styles[value] || { bg: "#F4F4F5", text: "#525252", border: "#D4D4D8" };
  const label = labels[value] || value;
  return (
    <span
      data-testid={`pill-${kind}-${value}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 text-xs font-medium border ${sharp ? "rounded-none" : "rounded-full"} ${className}`}
      style={{ background: style.bg, color: style.text, borderColor: style.border }}
    >
      <span className="inline-block w-1.5 h-1.5" style={{ background: style.text, borderRadius: 999 }} />
      {label}
    </span>
  );
};
